<template>
	<div>
		<v-data-table
			:headers="fieldList"
			:items="entityList"
			sort-by="id"
			:search="keyword"
			:footer-props="{ itemsPerPageOptions: [50, 100, 500, -1] }"
		>
			<template v-slot:top>
				<v-row no-gutters style="padding: 5px 0 0 0">
					<v-col cols="12" sm="6">
						<div class="d-flex px-2">
							<h2>File Upload</h2>
						</div>
					</v-col>
					<v-col></v-col>
					<v-col cols="12" sm="6">
						<div class="d-flex px-2">
							<v-text-field
								v-model="keyword"
								append-icon="mdi-magnify"
								label="Search"
								hide-details
								style="margin-right: 10px"
							></v-text-field>
						</div>
					</v-col>
				</v-row>
			</template>
			<template v-slot:item.action="{ item }">
				<v-btn fab x-small link @click="download(item.filename, item.name)">
					<v-icon>mdi-download</v-icon>
				</v-btn>
				<v-btn fab x-small style="margin-left: 10px" @click="showDelete(item.id)">
					<v-icon>mdi-delete</v-icon>
				</v-btn>
			</template>
			<template v-slot:no-data>Empty list</template>
		</v-data-table>

		<v-dialog v-model="dialogDelete" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Delete</span>
				</v-card-title>
				<v-card-text>Are you sure you want delete this?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="dialogDelete = false">Cancel</v-btn>
					<v-btn @click="remove" color="primary darken-1">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			entityList: [],
			dialogDelete: false,
			fieldList: [
				{ text: "Id", value: "id" },
				{ text: "Name", value: "name" },
				{ text: "Filename", value: "filename" },
				{ text: "Uploader", value: "title" },
				{ text: "", value: "action", sortable: false }
			],
			keyword: "",
			selectedId: null,
			baseLocation: axios.defaults.baseURL,
		};
	},
	mounted() {
		this.list();
		this.setHeaderTable();
	},
	methods: {
		list() {
			axios
				.get("/system/uploadedFile/list?experienceId=" + this.experienceId)
				.then((response) => {
					this.entityList = response.data;
				})
				.catch(() => {});
		},
		setHeaderTable() {
			if (this.$store.state.principal.type == 'Exhibition') {
				this.fieldList = [
					{ text: "Id", value: "id" },
					{ text: "Name", value: "name" },
					{ text: "Filename", value: "filename" },
					{ text: "Uploader", value: "title" },
					{ text: "", value: "action", sortable: false }
				]
			} else {
				this.fieldList = [
					{ text: "Id", value: "id" },
					{ text: "Name", value: "name" },
					{ text: "Filename", value: "filename" },
					{ text: "", value: "action", sortable: false }
				]
			}
		},
		showDelete(entityId) {
			this.selectedId = entityId;
			this.dialogDelete = true;
		},
		remove() {
			axios
				.post("/system/uploadedFile/delete", {
					id: this.selectedId
				})
				.then(() => {
					this.dialogDelete = false;
					this.list();
					this.selectedId = null;
				})
				.catch(() => {});
		},
		download(url, name) {
			axios({
				url: this.baseLocation + "/asset/file/" + url,
				method: 'GET',
				responseType: 'blob', // important
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', name);
				document.body.appendChild(link);
				link.click();
			});
		},
	}
};
</script>
